/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Close_TitleInputs */

const en_landing_close_title = /** @type {(inputs: Landing_Close_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get ready.`)
};

const pl_landing_close_title = /** @type {(inputs: Landing_Close_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do dzieła.`)
};

/**
* | output |
* | --- |
* | "Get ready." |
*
* @param {Landing_Close_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_close_title = /** @type {((inputs?: Landing_Close_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Close_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_close_title(inputs)
	return en_landing_close_title(inputs)
});